export default __webpack_public_path__ + "static/media/oopsShape.1cce99b6.svg";